export const Logo = ({ size = 32 }) => (
  <div className="flex items-center gap-3">
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="16" cy="16" r="15" stroke="#D4AF37" strokeWidth="1.5" />
      <path d="M16 4 L20 16 L16 14 L12 16 Z" fill="#D4AF37" />
      <path d="M4 16 L16 20 L14 16 L16 12 Z" fill="#D4AF37" opacity="0.5" />
      <circle cx="16" cy="16" r="2" fill="#060B14" stroke="#D4AF37" strokeWidth="1.5" />
    </svg>
    <div className="leading-tight">
      <div className="font-display text-base font-medium tracking-wider text-white">WINGMAN</div>
      <div className="hud-label text-[10px]">ALFRED · ACADEMY</div>
    </div>
  </div>
);
